import { East, InfoOutlined } from '@mui/icons-material';
import {
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/styles';
import { useWindowWidth } from '@react-hook/window-size';
import React from 'react';
import { HomeDashData, homeStyles } from '..';

export function BadgeLevel(props: {
  data?: HomeDashData;
  loading: boolean;
  isMobile: boolean;
}) {
  // Props
  const { data, loading, isMobile } = props;
  // Hooks
  const width = useWindowWidth();

  const isTopLvl = data?.NextLvlImagePath === null;

  const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#17191B',
      color: '#fff',
      maxWidth: 250,
      border: '1px solid #d0d0d0',
      borderRadius: 10,
      fontFamily: 'Lato',
      textAlign: 'center',
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: '#17191B',
      '&:before': {
        border: '1px solid #d0d0d0',
      },
    },
  }));

  return (
    <Box
      flex={1}
      p={1}
      sx={{
        ...homeStyles.box,
        minHeight: 120,
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          textTransform: 'uppercase',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: '16px',
          pb: 1,
        }}
      >
        Level Badge{' '}
        {data?.BadgeGeneralInfo && (
          <Tooltip
            title={data?.BadgeGeneralInfo || ''}
            arrow
            placement="bottom"
            slotProps={{
              tooltip: { sx: { backgroundColor: '#17191B', p: 1 } },
              arrow: { sx: { color: '#17191B' } },
            }}
          >
            <InfoOutlined
              fontSize="small"
              sx={{
                transform: 'scale(.8)',
                cursor: 'help',
                color: '#fff',
              }}
            />
          </Tooltip>
        )}
      </Box>
      {!loading && data !== undefined ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            height: '70%',
          }}
        >
          <CustomTooltip
            placement={isMobile ? 'top-start' : 'left'}
            arrow
            disableHoverListener={!data?.BadgeCurrentLvlInfo}
            title={
              <React.Fragment>
                <Typography
                  variant="subtitle2"
                  color="inherit"
                  sx={{ p: 1, whiteSpace: 'nowrap' }}
                >
                  Current Badge
                </Typography>
                <Box sx={{ fontStyle: 'italic', pb: 1, fontSize: 12 }}>
                  {data?.BadgeCurrentLvlInfo}
                </Box>
              </React.Fragment>
            }
          >
            <Box flex={1}>
              <img
                //@ts-ignore
                src={data?.LvlImagePath}
                alt={'Current Badge Level'}
                style={{
                  zIndex: 5,
                  height: isTopLvl
                    ? width < 600
                      ? '35%'
                      : '45%'
                    : isMobile
                      ? '50%'
                      : '65%',
                  width: isTopLvl
                    ? width < 600
                      ? '35%'
                      : '45%'
                    : isMobile
                      ? '50%'
                      : '65%',
                }}
              />
            </Box>
          </CustomTooltip>
          {!isTopLvl ? (
            <React.Fragment>
              <Box>
                <East sx={{ color: '#00000090' }} fontSize="large" />
              </Box>
              <Box
                flex={1}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CustomTooltip
                  placement={isMobile ? 'top-start' : 'left'}
                  arrow
                  title={
                    <React.Fragment>
                      <Typography
                        variant="subtitle2"
                        color="inherit"
                        sx={{ p: 1, whiteSpace: 'nowrap' }}
                      >
                        How To Upgrade Your Level!
                      </Typography>
                      <Box sx={{ fontStyle: 'italic', pb: 1, fontSize: 12 }}>
                        {data?.BadgeNextLvlInfo}
                      </Box>
                    </React.Fragment>
                  }
                >
                  <Box
                    sx={{
                      fontSize: 9,
                      fontFamily: 'Roboto',
                      letterSpacing: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img
                      src={data?.NextLvlImagePath || undefined}
                      alt={'Next Badge Level'}
                      style={{
                        height: isMobile ? '50%' : '65%',
                        width: isMobile ? '50%' : '65%',
                        marginTop: '5px',
                        cursor: 'help',
                      }}
                    />
                    Upgrade{' '}
                  </Box>
                </CustomTooltip>
              </Box>
            </React.Fragment>
          ) : null}
        </Box>
      ) : (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-evenly"
          pt={1}
        >
          <Skeleton variant="circular" width={70} height={70} />
          <East sx={{ color: '#00000090' }} fontSize="large" />
          <Skeleton variant="circular" width={70} height={70} />
        </Stack>
      )}
    </Box>
  );
}
